import {
  PageHeader,
  Row,
  Col,
  Button,
  Card,
  Input,
  Select,
  Skeleton,
  Modal,
  message,
} from "antd";
import { Fragment, useEffect, useState } from "react";
import {
  ROUTE_ANNOUNCEMENTS_CONFIG,
  ROUTE_FILE_CONFIGURATION,
} from "../../core/route/ui.routes";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Footer } from "antd/lib/layout/layout";
import { antdControlElements } from "@react-querybuilder/antd";
import "react-querybuilder/dist/query-builder.scss";
import type { RuleGroupType, ValueEditorProps } from "react-querybuilder";
import {
  QueryBuilder,
  defaultOperators,
  formatQuery,
} from "react-querybuilder";
import {
  getKeysAudience,
  getKeysAudienceValues,
  previewAudienceQuery,
  putAudienceQueryBuilder,
} from "../../core/store/reducers/annoucements.slice";
// import { keyLabelMapping } from "./components/fields";
import { SearchOutlined } from "@ant-design/icons";
import TableLayout from "../../shared/layouts/table.layout";
import { RootState } from "../../shared/constants";
import { debounce, saveInLocalStorageCache, validateLocalStorageCache } from "../../shared/utilities";
import { setBlurModal } from "../../core/store/reducers/settings.slice";
import CreateAudienceCSV from "./components/create-audience-csv.component";
import PopupMessageComponent from "../../shared/layouts/message.layout";
// import { fields } from './components/fields';

const initialQuery: RuleGroupType = { combinator: "and", rules: [] };

function CreateEditAudiencePage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const params: any = useParams();
  const screenType = {
    desktop: useMediaQuery({ minWidth: 992 }),
    tablet: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    mobile: useMediaQuery({ maxWidth: 767 }),
  };
  const { audiences } = useSelector(
    (state: RootState) => state.annoucements
  );
  const [selectedAudience, setSelectedAudience] = useState(null as any);
  const [audienceId, setAudienceId] = useState(params?.id as any);
  const [audienceName, setAudienceName] = useState("" as any);
  const [fields, setFields] = useState([] as any);
  const [query, setQuery] = useState(initialQuery as any);
  const [previewAudienceVisible, setPreviewAudienceVisible] = useState(
    false as boolean
  );
  const [csvUploadVisible, setCsvUploadVisible] = useState(false as boolean);
  const [modalVisible, setModalVisible] = useState(false as any);
  const [modalType, setModalType] = useState("" as any);
  const [modalButtons, setModalButtons] = useState((<></>) as any);
  const [modalTitle, setModalTitle] = useState("" as any);
  const [modalSubTitle, setModalSubTitle] = useState("" as any);
  const [enableSave, setEnableSave] = useState(true as any);

  useEffect(()=>{
    if(audienceId && audiences?.length > 0){
        const selectedAudience =  audiences?.filter((val:any)=>val?.audience_id == audienceId);
        if(selectedAudience?.length > 0){
            setSelectedAudience(selectedAudience[0]);
            setAudienceName(selectedAudience[0].audience_name)
            if(selectedAudience[0].audience_type == "query"){
                setQuery(JSON.parse(selectedAudience[0].query_json))
            }
            setEnableSave((selectedAudience[0].announcement_count != 0 || window.location.href.includes('view-audience')) ? false : true)
        }
    }
  }, [audienceId, audiences])
  const ExtendedValueEditor_Select = (props: ValueEditorProps) => {
    return (
      <>
      {/* <Form.Item name={props?.level + props?.path?.join("-")} style={{marginBottom: 0}}> */}
      <Select
        disabled={!enableSave}
        style={{ minWidth: "200px" }}
        value={props.value}
        mode={"multiple"}
        onChange={(v) => props.handleOnChange(v)}
        optionFilterProp="children"
        filterOption={(input, option: any) =>
          option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        options={props.values?.map((val: any) => {
          return { value: val.name, label: val.label };
        })}
      />
      {/* </Form.Item> */}
      </>
    );
  };
  useEffect(() => {
    // = keyLabelMapping?.map( (val:any)=>{
    //     return {
    //         label: val.label,
    //         name: val.sql_key,
    //         id: val.api_key,
    //         valueEditorType: 'multiselect',
    //         operators: defaultOperators.filter((op) => op.name === 'in'),
    //         values: await getKeyData(val.api_key),
    //         defaultValue: []
    //     }
    // })
    dispatch(getKeysAudience()).then((val:any)=>{
      if(val?.payload?.data?.data){
        prepareFields(val?.payload?.data?.data);
      }
    })
    
  }, []);
  async function prepareFields(keyLabelMapping:any) {
    let fieldsData = [];
    for (let k = 0; k < keyLabelMapping?.length; ++k) {
      let val = keyLabelMapping[k];
      fieldsData.push({
        label: val.label,
        name: val.sql_key,
        id: val.api_key,
        valueEditorType: "multiselect",
        operators: defaultOperators.filter((op) => op.name === "in"),
        values: await getKeyData(val.api_key),
        defaultValue: [],
      });
    }
    setFields(fieldsData);
  }
  async function getKeyData(api_key: string) {
    let cache = validateLocalStorageCache(api_key);
    if(cache !== false){
      return cache
    }
    const res = await dispatch(getKeysAudienceValues(api_key));
    if (res?.payload?.data?.data) {
      let data = res?.payload?.data?.data?.filter((val:any)=>val && val!=='')?.map((val: any) => {
        return { name: val, label: val };
      });
      saveInLocalStorageCache(api_key, data, 2*60)
      return data
    }
  }
  const getValueArray = (obj:any) => {
    let ret:any = [];
    obj.map((val:any)=>{
      if(val?.value){
        ret = [...ret, val?.value];
      }else if(val?.rules){
        ret = [...ret, ...getValueArray(val.rules)];
      }
    });
    return ret;
  }
  function onSave() {
    console.log(getValueArray(query?.rules))
    // let allFields = form?.getFieldsValue();
    // let data = Object.keys(allFields)?.filter((val:any)=>allFields[val]?.length == 0);
    let data = getValueArray(query?.rules);
    data = data?.filter((val:any)=>val?.length == 0)
    if(data?.length > 0){
      message.error("Atleast one rule is empty. Please fill all rules.", 10)
      return;
    }
    const payload = {
      ...(audienceId ? { audience_id: audienceId } : {}),
      audience_name: audienceName,
      query_json: JSON.stringify(query),
      sql_query: formatQuery(query, "sql"),
    };
    dispatch(putAudienceQueryBuilder(payload)).then((val: any) => {
      if (val?.payload?.data?.statusCode == 200) {
        openSuccessModal()
      }else{
        if(val?.payload?.data?.statusCode == 403){
          message.error(val?.payload?.data?.message, 10)
        }else{
          message.error("Some error occured while saving audience", 10)
        }
      }
    });
  }
  const closeModalPopup = () => {
    setModalVisible(false);
    setModalType("");
    setModalButtons(<></>);
    setModalSubTitle("");
    setModalTitle("");
    history.push(ROUTE_ANNOUNCEMENTS_CONFIG);
  };
  const openSuccessModal = () => {
    setModalTitle("Audience Saved.");
    setModalType("success");
    setModalSubTitle("");
    setModalButtons(<></>);
    setModalVisible(true);
  };

  useEffect(() => {
    dispatch(setBlurModal(previewAudienceVisible));
  }, [previewAudienceVisible]);
  return (
    <>
      <Fragment>
        <div style={{ height: "100vh", position: "relative" }}>
          <PageHeader
            ghost={false}
            title={
              <Row
                style={screenType.mobile ? { paddingLeft: "25px" } : {}}
                align="middle"
                gutter={8}
              >
                <Col className="title-text">
                  <span
                    style={{
                      cursor: "pointer",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                    }}
                    onClick={() => window.history.back()}
                  >
                    &lt;
                  </span>
                </Col>
                <Col className="title-text">
                  {!audienceId ? "Create" : enableSave ? "Edit" : 'View'} Audience
                </Col>
              </Row>
            }
            extra={
              <Row align="middle">
                <Col className="title-text">
                  {!audienceId && <Button
                    key="1"
                    onClick={() => {
                      setCsvUploadVisible(true);
                    }}
                    className="ant-btn-hover"
                  >
                    Or Upload CSV File
                  </Button>}
                </Col>
              </Row>
            }
          ></PageHeader>
          <Row className="content-area pt-4">
            <Col span={24}>
              <Card style={{ height: "calc(100vh - 220px)", overflow: "auto" }}>
                <Row>
                  <Col>
                    <h3 className="w600">1. Audience Name</h3>
                    <Input
                      disabled={!enableSave}
                      name="audienceName"
                      value={audienceName}
                      onChange={(e) => setAudienceName(e.target.value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <h3 className="w600 mt-4">2. Define Conditions</h3>
                    {/* <Form form={form}> */}
                    {fields?.length > 0 ? (
                      <QueryBuilder
                        disabled={!enableSave}
                        fields={fields}
                        query={query}
                        onQueryChange={setQuery}
                        controlClassnames={{
                          queryBuilder: "queryBuilder-branches",
                        }}
                        // controlElements={antdControlElements}
                        controlElements={{
                          ...antdControlElements,
                          valueEditor: ExtendedValueEditor_Select,
                        }}
                      />
                    ) : (
                      <Skeleton active={true} />
                    )}
                    {/* </Form> */}
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
          <Row className="audience-footer p-3">
            <Col span={24}>
              <Row>
                <Col span={24} className="title-text">
                  <svg
                    width="24"
                    height="20"
                    viewBox="0 0 24 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9971 8.03027C13.0416 8.03027 14.0434 7.61533 14.782 6.87672C15.5206 6.13811 15.9356 5.13634 15.9356 4.0918C15.9356 3.04725 15.5206 2.04548 14.782 1.30687C14.0434 0.568266 13.0416 0.15332 11.9971 0.15332C10.9526 0.15332 9.95079 0.568266 9.21218 1.30687C8.47357 2.04548 8.05863 3.04725 8.05863 4.0918C8.05863 5.13634 8.47357 6.13811 9.21218 6.87672C9.95079 7.61533 10.9526 8.03027 11.9971 8.03027ZM6.7458 6.71745C6.7458 7.41381 6.46917 8.08165 5.97677 8.57406C5.48436 9.06646 4.81652 9.34309 4.12015 9.34309C3.42379 9.34309 2.75594 9.06646 2.26354 8.57406C1.77113 8.08165 1.4945 7.41381 1.4945 6.71745C1.4945 6.02108 1.77113 5.35324 2.26354 4.86083C2.75594 4.36843 3.42379 4.0918 4.12015 4.0918C4.81652 4.0918 5.48436 4.36843 5.97677 4.86083C6.46917 5.35324 6.7458 6.02108 6.7458 6.71745ZM0.824962 16.3352C0.600844 16.2078 0.433011 16.0006 0.35497 15.7549C0.123658 15.0057 0.121232 14.2046 0.348004 13.454C0.574776 12.7034 1.02042 12.0376 1.62788 11.5418C2.23533 11.046 2.97694 10.7429 3.75774 10.6711C4.53854 10.5993 5.32298 10.7623 6.01062 11.139C4.59754 12.5277 3.71309 14.3658 3.50969 16.3365C3.47949 16.628 3.49131 16.9168 3.54251 17.1951C2.58436 17.1122 1.65637 16.8186 0.824962 16.3352ZM20.4517 17.1938C21.4097 17.1113 22.3377 16.8182 23.1692 16.3352C23.3929 16.2076 23.5602 16.0004 23.6379 15.7549C23.8696 15.0057 23.8723 14.2043 23.6457 13.4535C23.4191 12.7026 22.9735 12.0366 22.3659 11.5406C21.7584 11.0446 21.0166 10.7413 20.2356 10.6695C19.4547 10.5977 18.67 10.7608 17.9823 11.1377C19.3966 12.5263 20.282 14.365 20.4858 16.3365C20.5151 16.6229 20.5036 16.912 20.4517 17.1951V17.1938ZM22.4997 6.71745C22.4997 7.41381 22.2231 8.08165 21.7307 8.57406C21.2383 9.06646 20.5704 9.34309 19.8741 9.34309C19.1777 9.34309 18.5098 9.06646 18.0174 8.57406C17.525 8.08165 17.2484 7.41381 17.2484 6.71745C17.2484 6.02108 17.525 5.35324 18.0174 4.86083C18.5098 4.36843 19.1777 4.0918 19.8741 4.0918C20.5704 4.0918 21.2383 4.36843 21.7307 4.86083C22.2231 5.35324 22.4997 6.02108 22.4997 6.71745ZM5.83208 17.4695C5.7026 17.3535 5.60222 17.2087 5.53905 17.0468C5.47588 16.8849 5.45168 16.7104 5.46842 16.5374C5.63541 14.9219 6.39533 13.4257 7.60131 12.338C8.80729 11.2502 10.3737 10.6482 11.9978 10.6482C13.6218 10.6482 15.1882 11.2502 16.3942 12.338C17.6002 13.4257 18.3601 14.9219 18.5271 16.5374C18.5439 16.7104 18.5198 16.8849 18.4566 17.0469C18.3934 17.2088 18.293 17.3536 18.1634 17.4695C16.4754 19.0015 14.2767 19.8488 11.9971 19.8457C9.71797 19.8486 7.5197 19.0013 5.83208 17.4695Z"
                      fill="#EB872A"
                    />
                  </svg>
                  &nbsp; &nbsp; Audience Size
                </Col>
              </Row>
              <Row>
                <Col flex="auto">
                  <Button
                    className="ant-btn-hover"
                    disabled={!audienceName || audienceName == ""}
                    onClick={() => setPreviewAudienceVisible(true)}
                  >
                    Preview Audience Segment
                  </Button>
                </Col>
                {enableSave && <Col flex="none">
                  <Button
                    type="primary"
                    style={{ width: "200px" }}
                    onClick={onSave}
                    disabled={!audienceName || audienceName == ""}
                  >
                    Save
                  </Button>
                </Col> }
              </Row>
            </Col>
          </Row>
        </div>
        {previewAudienceVisible && (
          <Modal
            footer={false}
            open={previewAudienceVisible}
            className="preview-audience"
            width={"75vw"}
            onCancel={() => setPreviewAudienceVisible(false)}
            centered={true}
            title="Preview Audience Segment"
          >
            <PreviewAudienceSegmentQuery
              query={query}
            ></PreviewAudienceSegmentQuery>
          </Modal>
        )}
        {csvUploadVisible && (
          <CreateAudienceCSV
            selectedAudience={selectedAudience}
            formVisible={csvUploadVisible}
            setFormVisible={setCsvUploadVisible}
          ></CreateAudienceCSV>
        )}
        {modalVisible && (
          <PopupMessageComponent
            open={modalVisible}
            onCancel={closeModalPopup}
            title={modalTitle}
            subTitle={modalSubTitle}
            type={modalType}
            buttons={modalButtons}
          />
        )}
      </Fragment>
    </>
  );
}
export default CreateEditAudiencePage;

export const PreviewAudienceSegmentQuery = ({ query }: any) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState(null as any);
  const { loading, audiencePreview, paginationPreview } = useSelector(
    (state: RootState) => state.annoucements
  );
  useEffect(() => {
    if (query) {
      loadList(0);
    }
  }, [query, search]);
  const columns: any = [
    {
      title: "S. No.",
      key: "sno",
      dataIndex: "sno",
      width: "90px",
    },
    {
      title: "Employees Name",
      key: "employee_name",
      dataIndex: "RepName",
    },
    {
      title: "Employee Id",
      key: "employee_code",
      dataIndex: "employee_code",
    },
    {
      title: "Mobile No",
      key: "mobile_number",
      dataIndex: "Mobile_no",
    },
    {
      title: "Email",
      key: "email",
      dataIndex: "email",
    },
  ];
  const loadList = (offset: number = 0) => {
    let params = {
      offset: offset,
      limit: paginationPreview.limit,
      ...(search && search != "" ? { searchTerm: search } : {}),
    };
    let payload = {
      query: formatQuery(query, "sql"),
    };
    dispatch(
      previewAudienceQuery({
        payload,
        params,
      })
    );
  };
  const onPageChange = (e: any, pageSize: any) => {
    let offset = (e - 1) * paginationPreview.limit;
    loadList(offset);
  };
  return (
    <>
      <Row>
        <Col span={8}>
          <Input
            onChange={(e) => {
              debounce(setSearch(e.target.value), 1000);
            }}
            prefix={<SearchOutlined />}
            placeholder="Search by employee name"
          ></Input>
        </Col>
      </Row>
      {/* <Row>
        <Col span={24} className="sub-text py-2">
          Total Employees: <span>30,000</span> <Divider type="vertical" />
          Valid Mobile Numbers: <span>20,000</span> <Divider type="vertical" />
          Valid Email ID: <span>25,000</span>
        </Col>
      </Row> */}
      <Row>
        <Col span={24}>
          <TableLayout
            defaultCurrentPage={
              paginationPreview.offset / paginationPreview.limit + 1
            }
            loading={loading}
            buttonEvt={() => {}}
            dataSource={audiencePreview}
            filters="multiple"
            columns={columns}
            onChange={(e, ee) => onPageChange(e, ee)}
            total={paginationPreview.total}
            showTotal={true}
            pagination={{
              position: ["none", "none"],
              pageSize: paginationPreview.limit,
            }}
            paginationPosition="bottom"
            // maxWidth={1500}
            defaultPageSize={10}
            showSizeChangerFlag={false}
          />
        </Col>
      </Row>
    </>
  );
};
